import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[cardBody]',
  standalone: true
})
export class CardBodyDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
